import { render, staticRenderFns } from "./cultureActionDialog.vue?vue&type=template&id=270e7f78&"
import script from "./cultureActionDialog.vue?vue&type=script&lang=js&"
export * from "./cultureActionDialog.vue?vue&type=script&lang=js&"
import style0 from "./cultureActionDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports